import config, { Config } from './config';

const useConfig = (): Config => config;

export default useConfig;